import { money } from "@/lib/api";
import { CalendarClock } from "lucide-react";

// Rent is due on the 1st of each month, evaluated in U.S. Central Time.
export function nextRentDue(now = new Date()) {
  const ct = new Date(now.toLocaleString("en-US", { timeZone: "America/Chicago" }));
  const y = ct.getFullYear();
  const m = ct.getMonth();
  const d = ct.getDate();
  let dueY = y;
  let dueM = m;
  if (d > 1) {
    dueM = m + 1;
    if (dueM > 11) { dueM = 0; dueY = y + 1; }
  }
  const due = new Date(dueY, dueM, 1);
  const days = Math.round((due - new Date(y, m, d)) / 86400000);
  return { due, days };
}

export const RentDueNudge = ({ lease }) => {
  const { due, days } = nextRentDue();
  const dueLabel = due.toLocaleDateString("en-US", { month: "long", day: "numeric" });
  const when = days <= 0 ? "due today" : days === 1 ? "due tomorrow" : `due in ${days} days`;
  const urgent = days <= 3 && !lease.autopay_enabled;
  return (
    <div data-testid="rent-due-nudge" className="mt-5 pt-5 border-t border-white/15 flex flex-wrap items-center justify-between gap-3">
      <div className="flex items-center gap-2.5">
        <CalendarClock className="h-5 w-5 text-white/80" strokeWidth={1.75} />
        <div>
          <p className="text-sm font-medium">Next rent payment {when}</p>
          <p className="text-xs text-white/60" data-testid="rent-due-date">
            {money(lease.monthly_rent)} · {dueLabel}{lease.autopay_enabled ? " · Auto-Pay will remind you" : ""}
          </p>
        </div>
      </div>
      <span data-testid="rent-due-chip" className={`inline-flex items-center rounded-full px-3 py-1.5 text-xs font-semibold ${urgent ? "bg-terracotta text-white" : "bg-white/15 text-white"}`}>
        {days <= 0 ? "Due today" : `${days} day${days === 1 ? "" : "s"} left`}
      </span>
    </div>
  );
};
